import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 2 2 22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CircleSlash2";
const CircleSlash2 = memo(themed(Icon));
export {
  CircleSlash2
};
//# sourceMappingURL=circle-slash-2.js.map
